<template>
  <div class="member-area-tab-cover-config-component">
    <div class="my-3">
      Imagens de capa
    </div>
    <small class="text-secondary d-block mb-6">
      Defina como será a capa da tela inicial na sua área de membros.
      <!-- Opte por utilizar imagem, vídeo ou até mesmo os dois. -->
    </small>
    <!-- <div class="my-3 fs-14">
      Qual modo de capa você deseja?
    </div> -->

    <div class="row pt-5 pb-2 mb-5">
      <div class="col-lg-10 py-3">
        <div class="my-3 fs-14">
          Capa versão desktop
        </div>
        <cover-option :form="form" :errors="errors" option-type="image" />
        <cover-option :form="form" :errors="errors" option-type="video" />
        <cover-option
          :form="form"
          :errors="errors"
          option-type="image_and_video"
        />
      </div>
    </div>
    <hr />

    <div class="mt-9 fs-14">
      Capa versão mobile
    </div>
    <div class="row pt-5 pb-2 mb-5">
      <div class="col-lg-10 py-3">
        <cover-option
          mobile
          :form="form"
          :errors="errors"
          option-type="image"
        />
        <cover-option
          mobile
          :form="form"
          :errors="errors"
          option-type="video"
        />
      </div>
    </div>
    <hr />
  </div>
</template>
<script>
import CoverOption from "./CoverOption.vue";
export default {
  components: { CoverOption },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
